import React from "react";
import { convertFileToBase64 } from "../../../../components/utils/utils";
import { Col, Form, Row } from "antd";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";

interface IdentityPapersInfoProps {
  form: any;
}

const IdentityPapersInfo = ({ form }: IdentityPapersInfoProps) => {
  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[], fieldName: string) => {
    const file = fileList[0]?.originFileObj;
    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };
        form.setFieldsValue({
          [fieldName]: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>تحميل الأوراق الثبوتية</span>
      </div>
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="family_record_image_1_ids"
            label="إرسال صورة سجل الأسرة 1"
            labelCol={{ className: "takaful--label-style" }}
          >
            <UploadInput
              accept="*"
              text="إرسال صورة سجل الأسرة 1"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={(fileList) =>
                handleFileChange(fileList, "family_record_image_1_ids")
              }
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="family_record_image_2_ids"
            label="إرسال صورة سجل الأسرة 2"
            labelCol={{ className: "takaful--label-style" }}
          >
            <UploadInput
              accept="*"
              text="إرسال صورة سجل الأسرة 2"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={(fileList) =>
                handleFileChange(fileList, "family_record_image_2_ids")
              }
            />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="family_record_image_3_ids"
            label="إرسال صورة سجل الأسرة 3"
            labelCol={{ className: "takaful--label-style" }}
          >
            <UploadInput
              accept="*"
              text="إرسال صورة سجل الأسرة 3"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={(fileList) =>
                handleFileChange(fileList, "family_record_image_3_ids")
              }
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default IdentityPapersInfo;
